import React, { useState } from "react";
import {
	Box,
	Typography,
	Tabs,
	Tab,
	Table,
	TableHead,
	TableRow,
	TableCell,
	TableBody,
	Paper,
	CircularProgress,
} from "@mui/material";
import UploadEditor from "./UploadEditor.tsx";
import { useAppDispatch, useAppSelector } from "../../store/hooks.ts";
import { removePendingUpload } from "../../store/slices/pendingUploadsSlice.ts";

const PendingUploads = () => {
	const dispatch = useAppDispatch();

	const pendingUploads = useAppSelector(
		(state) => state.pendingUploads.pendingUploads
	);
	const loading = useAppSelector((state) => state.pendingUploads.loading);

	const [tabIndex, setTabIndex] = useState(0);

	const [selectedUpload, setSelectedUpload] = useState(null);

	const handleTabChange = (event, newIndex) => {
		setTabIndex(newIndex);
	};

	return (
		<Box sx={{ maxWidth: "100%", mt: 2 }}>
			<Tabs
				value={tabIndex}
				onChange={handleTabChange}
				indicatorColor="primary"
				textColor="primary"
			>
				<Tab label="Pending Uploads" />
				{/* Future tab: <Tab label="Resolved" /> */}
			</Tabs>

			<Box sx={{ mt: 3 }}>
				{tabIndex === 0 && (
					<>
						{loading ? (
							<CircularProgress />
						) : pendingUploads.length === 0 ? (
							<Typography variant="body1">
								You currently have no pending uploads.
							</Typography>
						) : (
							<Paper elevation={2}>
								<Table>
									<TableHead>
										<TableRow>
											<TableCell>Source File</TableCell>
											<TableCell>Status</TableCell>
											<TableCell>Type</TableCell>
											<TableCell>Notes</TableCell>
											<TableCell>Created At</TableCell>
										</TableRow>
									</TableHead>
									<TableBody>
										{pendingUploads.map((upload) => (
											<TableRow
												key={upload.id}
												hover
												sx={{ cursor: "pointer" }}
												onClick={() =>
													setSelectedUpload(upload)
												}
											>
												<TableCell>
													{upload.source_file}
												</TableCell>
												<TableCell>
													{upload.status}
												</TableCell>
												<TableCell>
													{upload.type}
												</TableCell>
												<TableCell>
													{upload.notes}
												</TableCell>
												<TableCell>
													{new Date(
														upload.created_at
													).toLocaleString()}
												</TableCell>
											</TableRow>
										))}
									</TableBody>
								</Table>
							</Paper>
						)}
					</>
				)}
			</Box>
			{selectedUpload && (
				<Box mt={4}>
					<Typography variant="h6">Review Pending Upload</Typography>
					<UploadEditor
						upload={selectedUpload}
						onClose={() => setSelectedUpload(null)}
						onResolveSuccess={() => {
							setSelectedUpload(null);
							// fetchPendingUploads(); // refresh list
							dispatch(removePendingUpload(selectedUpload.id));
						}}
					/>
				</Box>
			)}
		</Box>
	);
};

export default PendingUploads;
